<template>
	<el-card>
		<div slot="header" class="header">
			<img src="../image/schedule.png" style="margin-left:2px">
			<span><strong>Schedule</strong></span>
		</div>
		<ScheduleForm :population="population"></ScheduleForm>
		<ScheduleTable :schedule="schedule"></ScheduleTable>
	</el-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import OverviewCard from '..'
import ScheduleForm from './Form'
import ScheduleTable from './Table'

export default {
	name: 'population-schedule-card',
	extends: OverviewCard,

	mounted() {
		let today = Date.now() - Date.now() % 86400000
		// this.loadSchedule({
		// 	start: today,
		// 	end: today + 86400000 * 7
		// })
	},

	computed: {
		...mapGetters('provider', [
			'getSchedule'
		]),
		schedule() {
			return this.getSchedule
		}
	},

	methods: {
		...mapActions('provider', [
			'loadSchedule'
		])
	},

	components: {
		ScheduleForm,
		ScheduleTable
	}
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>
